<template>
  <div>
    <b-modal
      id="modal-modify-eticket-refund-ticket-vn1a"
      title="Tính giá hoàn vé"
      title-class="text-airline font-medium-4 font-weight-bolder"
      centered
      no-close-on-backdrop
      body-class="p-50"
      size="lg"
      @show="showModalRefundTicket"
    >
      <template #modal-footer="{close}">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          size="md"
          variant="outline-secondary"
          class="center rounded-pill width-100"
          @click="close()"
        >
          {{ $t('reservation.close') }}
        </b-button>

        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="btn-gradient mt-lg-25  border-0"
          pill
          :disabled="isEmpty(indexSelectedTicketToRefund)"
          @click="submitCheckPriceAmount"
        >
          <span class="align-middle">{{
            $t('reservation.historyActions.CALCULATE_PRICE')
          }}</span>
        </b-button>
      </template>

      <!-- ANCHOR - Chọn số vé -->
      <b-card :body-class="`p-50`">
        <div class="custom-label-checkbox">
          <b-form-group>
            <template #label>
              <b-form-checkbox
                v-if="listPaxsData.length > 1"
                v-model="allSelected"
                aria-describedby="flights"
                aria-controls="flights"
                class="py-0 pt-1"
                @change="toggleAll"
              >
                <div
                  class="text-body-2 font-weight-bold"
                  style="padding-bottom: 13px"
                >
                  {{ allSelected ? $t('reservation.unselectAll') : $t('reservation.selectAll') }}
                </div>
              </b-form-checkbox>
            </template>

            <template #default="{ ariaDescribedby }">
              <b-form-checkbox-group
                v-model="indexSelectedTicketToRefund"
                :aria-describedby="ariaDescribedby"
                stacked
                name="flights"
              >
                <b-form-checkbox
                  v-for="(ticket, index) in listPaxsData"
                  :key="index"
                  :value="ticket"
                  class="mb-50  ml-50"
                  @change="selectTicketHandle(ticket)"
                >
                  <div class="d-flex flex-wrap gap-1 align-items-center">
                    <span class="text-warning fw-600">{{ `${ticket.number} ` }}</span>
                    <small class="mr-25 fw-600">({{ ticket.paxId }})</small>
                    <span class="mr-50 fw-600">{{ `${ticket.lastName}/${ticket.firstName}` }}</span>
                    <span class="mr-50 text-dark font-weight-bold">{{ resolveSegmentsInEticket(ticket.segments) }}</span>
                    <b-badge
                      variant="info"
                      class="px-50 ml-50 rounded-lg fw-700"
                    >
                      {{ ticket.ticketType }}
                    </b-badge>
                    <span :class="`ml-25 fw-600 ${['OK', 'OPEN', 'EMD'].includes(ticket.status) ? 'text-success' : 'text-warning'}`">
                      {{ ticket.status }}
                    </span>
                  </div>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </template>
          </b-form-group>
        </div>
      </b-card>

      <div class="mt-1 shadow">
        <b-alert
          show
          variant="warning"
          class="mb-50 p-50 fw-700"
        >
          <div class="text-danger">
            Lưu ý: <br>
            <span v-if="['VN1A', 'VN1A_MT'].includes(reservationsData.source)">
              - Vé đa hành trình/nhiều chặng, vé khứ hồi đã sử dụng một chặng cần hoàn, LH Booker hỗ trợ!
            </span> <br>
            <span>
              - Bạn phải chắc chắn nắm được điều kiện hoàn vé. Các trường hợp không
              chắc chắn vui lòng liên hệ Booker.
            </span> <br>
            <span v-if="['VN1A', 'VN1A_MT'].includes(reservationsData.source)">
              - Nếu hoàn vé người lớn có em bé đi cùng sẽ bắt buộc hoàn cả vé em bé. <br>
              - Số vé hoàn sẽ không void được.
            </span>
          </div>
        </b-alert>
      </div>
    </b-modal>

    <!-- SECTION - MODAL REFUND TICKET -->
    <b-modal
      id="modal-modify-eticket-refund-ticket-price-vn1a"
      :title="$t('reservation.refundTicket')"
      title-class="text-airline font-medium-4 font-weight-bolder"
      centered
      size="lg"
      no-close-on-backdrop
    >
      <!-- @show="showModalCheckPrice" -->
      <template #modal-footer="{close}">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          size="md"
          variant="outline-danger"
          class="center rounded-pill width-100"
          @click="close()"
        >
          {{ $t('reservation.close') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="btn-gradient mt-lg-25  border-0"
          pill
          :disabled="!isConfirm"
          @click="submitRefundTicket"
        >
          <span class="align-middle">
            {{ $t('reservation.refundTicket') }}
          </span>
        </b-button>
      </template>

      <b-overlay
        :show="loading"
        rounded="sm"
        no-fade
        variant="transparent"
        spinner-variant="info"
        opacity="0.85"
      >
        <!-- <b-row class="mb-sm-1 mb-md-25 flex-nowrap">
            <b-col md="6">
              Tổng tiền vé:
            </b-col>
            <b-col md="6">
              <span v-if="priceRefund && isNumber(priceRefund.subAmount)">{{ formatterAmount(priceRefund.subAmount) }}</span>
            </b-col>
          </b-row> -->

        <!-- <b-row class="mb-sm-1 mb-md-25 flex-nowrap">
            <b-col md="6">
              Phí hoàn:
            </b-col>
            <b-col md="6">
              <span v-if="priceRefund && isNumber(priceRefund.amount)">{{ getTotalRefundAmount(priceRefund) }}</span>
            </b-col>
          </b-row> -->

        <!-- <b-row class="mt-sm-1 mt-md-50 flex-nowrap">
            <b-col
              md="6"
              class="font-weight-bolder text-dark"
            >
              Tổng tiền hoàn:
            </b-col>
            <b-col md="6">
              <span
                v-if="priceRefund && isNumber(priceRefund.amount)"
                class="font-weight-bolder"
              >{{ formatterAmount(priceRefund.amount) }}</span>
            </b-col>
          </b-row> -->

        <b-table
          v-if="resRefundAmount"
          :items="resRefundAmount.eticketsRefund"
          :fields="tableRefundAmountColumns"
          hover
          small
          responsive
          outlined
          thead-class="text-nowrap text-center"
          tbody-class="text-nowrap text-center fw-700"
          show-empty
          no-border-collapse
          :empty-text="$t('noMatchingResult')"
        >
          <template
            v-for="column in tableRefundAmountColumns"
            #[`head(${column})`]="data"
          >
            <span
              :key="column.key"
              class="text-dark text-nowrap"
            >
              {{ $t(`reservation.historyActions.columns.${data.column}`) }}
            </span>
          </template>

          <template #cell(passenger)="{ item }">
            <span class="fw-700">{{ item?.name || '-' }}</span>
          </template>

          <template #cell(segments)="{ item }">
            {{ item.segments.map(segment => segment ?? '-').join(', ') }}
          </template>

          <template #cell(total)="{ item }">
            <span>{{ formatCurrency(item.total) }}</span>
          </template>

          <template #cell(penalty)="{ item }">
            <span class="text-danger fw-700">{{ formatCurrency(item.penalty) }}</span>
          </template>

          <template #cell(totalRefund)="{ item }">
            <span class="text-warning fw-700">{{ formatCurrency(item.totalRefund) }}</span>
          </template>
        </b-table>
      </b-overlay>

      <IAmConfirm :is-confirm.sync="isConfirm" />
    </b-modal>

    <ModalVoidTicketCancelAlert :title="'Hoàn vé'" />
  </div>
</template>

<script>
import {
  BModal,
  BAlert,
  BCard,
  BButton,
  BOverlay,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormGroup,
  BTable,
  BBadge,
} from 'bootstrap-vue'
import { ref, toRefs, watch } from '@vue/composition-api'
import isEmpty from 'lodash/isEmpty'
import capitalize from 'lodash/capitalize'
import isNumber from 'lodash/isNumber'

import IAmConfirm from '@/components/IAmConfirm.vue'
import { formatCurrency, convertISODateTime } from '@/@core/utils/filter'
import store from '@/store'

import useReservationHandle from '@reservation/useReservationHandle'

import useToast from '@useToast'

export default {
  components: {
    BModal,
    BAlert,
    BCard,
    BButton,
    BFormCheckboxGroup,
    BFormGroup,
    BFormCheckbox,
    BOverlay,
    BTable,
    BBadge,
    IAmConfirm,

    ModalVoidTicketCancelAlert: () => import('./ModalVoidTicketCancelAlert.vue'),
  },
  props: {
    reservationsData: {
      type: Object,
      required: true,
    },
    paxsData: {
      type: Array,
      required: true,
    },
  },
  setup(props, { root }) {
    const { toastError } = useToast()
    const { refundTicketAmount, refundTickets } = useReservationHandle()
    const bookingData = toRefs(props).reservationsData
    const listPaxsData = toRefs(props).paxsData

    const priceRefund = ref()
    const isConfirm = ref(false)
    const loading = ref(true)
    const resRefundAmount = ref(null)

    const indexSelectedTicketToRefund = ref([])

    // ANCHOR - SELECT ALL ====================
    const allSelected = ref(false)
    function toggleAll(isChecked) { // isChecked: Boolean
      indexSelectedTicketToRefund.value = isChecked ? listPaxsData.value.slice() : []
    }
    watch(indexSelectedTicketToRefund, newValue => {
      if (newValue.length === 0) {
        allSelected.value = false
      } else if (newValue.length === listPaxsData.value.length) {
        allSelected.value = true
      } else {
        allSelected.value = false
      }
    })

    function selectTicketHandle(ticket) { // NOTE: chỉ để check em bé và auto select/remove với VN1A
      if (!['VN1A', 'VN1A_MT'].includes(bookingData.value.source)) return
      if (['ADULT'].includes(ticket.paxType)) { // Chọn vé ADT có INF đi cùng > push vé INF đi cùng
        const infantFollow = listPaxsData.value.find(tk => ['INFANT'].includes(tk.paxType) && (tk.parentPaxId === ticket.paxId))
        const selectedParent = indexSelectedTicketToRefund.value.some(tk => tk.paxId === ticket.paxId)
        const selectedInfant = indexSelectedTicketToRefund.value.some(tk => tk?.parentPaxId === ticket.paxId)
        if (selectedParent && !selectedInfant && infantFollow) {
          indexSelectedTicketToRefund.value.push(infantFollow)
        }
      }
      if (['INFANT'].includes(ticket.paxType)) { // Huỷ vé INF > huỷ cả vé ADT đi cùng
        const parentIndex = indexSelectedTicketToRefund.value.findIndex(tk => tk.paxId === ticket.parentPaxId)
        if (!indexSelectedTicketToRefund.value.some(tk => tk.paxId === ticket.paxId) && (parentIndex !== -1)) {
          indexSelectedTicketToRefund.value.splice(parentIndex, 1)
        }
      }
    }

    // ANCHOR - CHECK PRICE ====================
    function resolveSegmentsInEticket(segments) {
      const result = []
      if (!isEmpty(segments)) {
        segments.forEach(item => {
          result.push(`${convertISODateTime(item.departureDate, 'UTC').dayMonth}-${item.departure}${item.arrival}`)
        })
      }
      const dataReturn = !isEmpty(result) ? result.join(', ') : ''
      return dataReturn
    }

    function showModalRefundTicket() {
      resRefundAmount.value = null
      indexSelectedTicketToRefund.value = listPaxsData.value?.slice()
    }

    function submitCheckPriceAmount() {
      isConfirm.value = false
      loading.value = true

      resRefundAmount.value = null

      const payload = {
        source: bookingData.value.source,
        pnrNumber: bookingData.value.bookingCode,
        refundTickets: indexSelectedTicketToRefund.value.map(p => ({
          paxId: p.paxId,
          ticketNumber: p.number,
          isEMD: p.ticketType !== 'TKT',
          bookingClass: p?.segments?.map(s => s?.bookingClass)?.join(' | '),
        })),
      }

      store.dispatch('app/setLoading', true)

      refundTicketAmount(payload)
        .then(res => {
          resRefundAmount.value = res
        })
        .then(() => {
          this.$bvModal.show('modal-modify-eticket-refund-ticket-price-vn1a')
        })
        .catch(error => {
          console.error(error)
          toastError({
            title: 'messagesList.error',
            content: 'Lỗi lấy giá hoàn vé, vui lòng thử lại!',
          })
        })
        .finally(() => {
          store.dispatch('app/setLoading', false)
          loading.value = false
          // resRefundAmount.value = {
          //   eticketsRefund: [
          //     {
          //       firstName: 'HOANG',
          //       lastName: 'LONG',
          //       ticketNumber: '738-2300007483',
          //       paxType: 'ADULT',
          //       netFare: 599000,
          //       tax: 617000,
          //       total: 1216000,
          //       totalRefund: 716000,
          //       penalty: 500000,
          //       noShowFee: 0,
          //       segments: [
          //         {
          //           segmentId: '1',
          //           departure: 'HAN',
          //           arrival: 'DAD',
          //           departureDate: '2024-05-30T10:00:00.000Z',
          //           bookingClass: 'E',
          //           status: 'OK',
          //           ticketStatus: 'I',
          //         },
          //       ],
          //       isDomestic: true,
          //       isNoneUsed: true,
          //       noShow: false,
          //       refund: true,
          //     },
          //   ],
          //   pnr: '6M9WFM',
          //   refundKey: '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',
          // }

          // this.$bvModal.show('modal-modify-eticket-refund-ticket-price-vn1a')
        })
    }

    // ANCHOR - SUBMIT REFUND ====================
    function submitRefundTicket() {
      const payload = {
        source: bookingData.value.source,
        pnrNumber: resRefundAmount.value.pnr,
        agencyCode: bookingData.value.agency,
        paxCode: bookingData.value.paxContact.code,
        refundTickets: indexSelectedTicketToRefund.value.map(p => ({
          paxId: p.paxId,
          ticketNumber: p.number,
          isEMD: p.ticketType !== 'TKT',
          bookingClass: p?.segments?.map(s => s?.bookingClass)?.join(' | '),
        })),
        refundKey: resRefundAmount.value.refundKey,
      }

      store.dispatch('app/setLoading', true)

      refundTickets(payload)
        .then(() => {
          Array.from(window.document.querySelectorAll('.modal.show'))
            .map(el => el.id)
            .forEach(id => {
              root.$root.$emit('bv::hide::modal', id)
            })
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          store.dispatch('app/setLoading', false)
          this.$bvModal.show('modal-void-ticket-cancel-alert')
        })
    }

    const tableRefundAmountColumns = [
      'passenger',
      'segments',
      'ticketNumber',
      'total',
      'penalty',
      'totalRefund',
    ]

    return {
      loading,
      priceRefund,
      bookingData,
      isConfirm,
      resRefundAmount,
      allSelected,
      toggleAll,
      listPaxsData,
      indexSelectedTicketToRefund,

      isEmpty,
      capitalize,
      isNumber,
      formatCurrency,
      submitRefundTicket,
      convertISODateTime,
      submitCheckPriceAmount,
      resolveSegmentsInEticket,

      showModalRefundTicket,
      tableRefundAmountColumns,

      selectTicketHandle,
    }
  },
}
</script>
